import React from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { useNavigate } from "react-router-dom";

const NoPhotoVerification = ({ handleNext, handleCancel, handleBack }) => {
  const navigate = useNavigate();

  const handlePartnerStore = (e) => {
    e.preventDefault();
    navigate("/app/photo-id");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a form element
    const form = document.createElement("form");

    // Set method to GET and the action to your desired URL
    form.method = "POST";
    form.action =
      (process.env.REACT_APP_API_URL || "/api") + "/application/liveness"; // Set your redirect URL or endpoint
    // Append the form to the body
    document.body.appendChild(form);

    // Submit the form to trigger a GET request and follow any redirects (302)
    form.submit();
  };

  return (
    <>
      <div className="intro no-min-height">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kāore anō kia oti i a koe tō hāpono whakaahua
        </h1>
        <hr />
        <h1 className="intro-title">
          You have not completed photo verification
        </h1>

        <div className="step-container">
          <p className="mb-4">
            If you do not complete photo verification online, you'll need to
            finish your application in person at a RealMe partner store.
          </p>
        </div>
        <h2 className="step-title mb-2">How would you like to continue?</h2>
        <br />
      </div>

      <div className="step-button-container">
        <SubmitButton
          text={"Try photo verification again"}
          onClick={handleSubmit}
        />
      </div>
      <div className="checkbox-wrapper mb-5">
        <label className="terms-label">
          <a href="#" className="cancel-link" onClick={handlePartnerStore}>
            I want my photo taken at a RealMe partner store instead
          </a>
        </label>
      </div>
    </>
  );
};

export default NoPhotoVerification;
